import React from "react";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect, Dispatch } from "react-redux";
import { RouteProps, Redirect, RouterProps } from "react-router";
import { Grid, Typography } from "material-ui";
import { SetShowBackNavigation } from "ducks/common";
import { env } from "../../util/env";

interface IAboutPageStateProps {}
interface IAboutPageDispatchProps {
    ShowBackNavigation: () => void;
    HideBackButton: () => void;
}

type IAboutPageProps = IAboutPageDispatchProps & RouterProps & RouteProps;

class AboutPage extends React.Component<IAboutPageProps, IAboutPageStateProps> {
    componentDidMount() {
        this.props.ShowBackNavigation();
    }

    componentWillUnmount() {
        this.props.HideBackButton();
    }

    public render() {
        return (
            <div className="AboutPage">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid
                            className="text-container"
                            item
                            xs={12}
                            sm={10}
                            md={10}
                            lg={10}
                        >
                            <h2>1. 1. Tietoa Mobiilipankista</h2>

                            <h3>
                                1.1. Rekisteröityminen ja sisäänkirjautuminen
                            </h3>

                            <Typography>
                                Voit rekisteröityä Suomen Hypoteekkiyhdistyksen 
                                (jäljempänä ”Hypo”) Mobiilipankkiin (jäljempänä 
                                ”Mobiilipankki”) käyttäen vahvaa sähköistä 
                                tunnistamista. Voit luoda rekisteröitymisen 
                                yhteydessä omat kirjautumisessa käytettävät 
                                tunnukset tai valita, että kirjaudut Mobiilipankkiin 
                                aina käyttäen vahvaa sähköistä tunnistamista. Voit 
                                myöhemmin muuttaa valintaasi kirjautua 
                                Mobiilipankkiin.
                            </Typography>

                            <h3>1.2. Mobiilipankissa esitetyt tiedot</h3>

                            <Typography>
                                Mobiilipankissa voit katsoa tilien ja 
                                lainojen tietoja. Tili- ja lainatiedot ovat 
                                pääsääntöisesti edellisen pankkipäivän tietoja. 
                                Tilikirjausten ja maksusuoritusten osalta 
                                viive voi olla noin 2-6 pankkipäivää. 
                                Tiliotteet muodostuvat tiliotekautta seuraavan 
                                kuukauden 5. päivä.
                                <br />
                                <br />
                                Mobiilipankissa julkaistaan myös Hypon tai 
                                samaan Hypo-konserniin kuuluvien yhtiöiden 
                                yleisiä tiedotteita ja uutisia. Hypo ja sen 
                                kanssa samaan konserniin kuuluvat yhtiöt 
                                voivat lähettää Mobiilipankkiin myös tuote- ja 
                                palvelukohtaisia viestejä ja tiedotteita, 
                                sen mukaan kuin niistä on tuote- ja 
                                palvelukohtaisissa sopimuksissa sovittu.
                            </Typography>

                            <h3>1.3. Toimeksiannot</h3>

                            <Typography>
                                Mobiilipankissa voit antaa omiin tuotteisiin 
                                ja palveluihin liittyviä toimeksiantoja tai 
                                hakea uutta lainaa. Toimeksiannot ja hakemukset 
                                otetaan käsittelyyn pääsääntöisesti seuraavana 
                                pankkipäivänä. Mahdollisia toimeksiantoja ovat 
                                nostopyyntö omalta tai käyttöoikeudelliselta 
                                tililtä vastatilille ja olemassa olevan oman 
                                lainan muutospyyntö (maksupäivän muutos, 
                                lyhennysvapaa, maksuaikataulun tai -erän muutos).
                            </Typography>

                            <h3>1.4. Viestitoiminto</h3>

                            <Typography>
                                Mobiilipankissa voit lähettää Hypolle ja 
                                vastaanottaa Hypolta vapaamuotoisia viestejä. 
                                Viestintä on toteutettu tietoturvallisesti ja 
                                voit jakaa viesteissä omia palveluitasi 
                                koskevia tietoja. Viestit ovat luettavissa 
                                vain Mobiilipankin sisällä.
                            </Typography>

                            <h3>1.5. Tietokannan laajuus ja tietolähteet</h3>

                            <Typography>
                                Tilejä ja talletuksia, luottoja ja niiden 
                                vakuuksia koskevat tiedot tulevat Hypon 
                                pankkijärjestelmästä. Vakuuksia koskevia 
                                tietoja täydennetään Tilastokeskuksen 
                                tuottamalla ja julkaisemalla tiedolla. 
                                Lisäksi Mobiilipankissa näytetään itse 
                                palveluun syöttämiäsi tietoja. 
                            </Typography>

                            <h3>1.6. Linkittäminen ja selainsuositukset</h3>

                            <Typography>
                                Sähköisessä muodossa olevaa linkkiä 
                                Mobiilipankkiin ei saa laittaa julkisesti 
                                saataville. Linkin saa kuitenkin tallentaa 
                                henkilökohtaista käyttöä varten esim. 
                                selaimeen suosikkeihin.
                            </Typography>
                            <br />
                            <Typography>
                                Mobiilipankkia suositellaan käytettäväksi 
                                yleisimmillä selaimilla ja laitteilla. 
                                Mobiilipankin ulkoasu saattaa poiketa tai 
                                jokin toiminto ei onnistu harvinaisemmilla tai 
                                vanhemmilla selaimilla ja/tai laitteilla. 
                                Näistä suosituksista ja niiden noudattamisesta 
                                riippumatta vastaat itse kokonaisuudessaan 
                                kaikkien niiden laitteiden, ohjelmistojen 
                                sekä viestintä- ja tietoliikenneyhteyksien 
                                teknisestä toimivuudesta, joilla käytät 
                                Mobiilipankkia. 
                            </Typography>

                            <h3>1.7. Ongelmatilanteet</h3>

                            <Typography>
                                Mobiilipankkia koskevissa ongelmatilanteissa 
                                voit olla yhteydessä Hypoon Mobiilipankin 
                                viestillä, Asiakasviestillä osoitteessa&nbsp;
                                <a href="www.hypo.fi">www.hypo.fi</a>, 
                                sähköpostilla&nbsp;
                                <a href="mailto:hypo@hypo.fi">hypo@hypo.fi</a>, 
                                kirjallisesti, 
                                puhelimitse tai asioimalla Hypon konttorissa.
                                <br />
                                <br />
                                Yhteystiedot:
                                <br />
                                Käyntiosoite: Yrjönkatu 9 A, 00120 Helsinki
                                <br />
                                Postiosoite: PL 509, 00101 Helsinki
                                <br />
                                Puhelin (vaihde): +358 9 228 361
                                <br />
                                Sähköposti:&nbsp;
                                <a href="mailto:hypo@hypo.fi">hypo@hypo.fi</a>
                                {env.APP_VERSION && env.APP_VERSION.length > 0 && (
                                    <React.Fragment>
                                        <br />
                                        <br />
                                        Tietoa sovelluksesta:
                                        <br />
                                        Sovelluksen versio: {env.APP_VERSION}
                                    </React.Fragment>
                                )}
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): IAboutPageStateProps => {
    return {
        ...mapStateToProps,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IAboutPageDispatchProps => {
    return {
        ShowBackNavigation: () => {
            return dispatch(SetShowBackNavigation(true));
        },
        HideBackButton: () => {
            return dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AboutPage);



// WEBPACK FOOTER //
// ./src/views/about/AboutPage.tsx